/**
 * Available meta tags for customisation
 */
var MetaTag;
(function (MetaTag) {
    MetaTag["OG_URL"] = "og:url";
    MetaTag["OG_SITE_NAME"] = "og:site_name";
    MetaTag["OG_IMAGE"] = "og:image";
    MetaTag["OG_IMAGE_ALT"] = "og:image:alt";
    MetaTag["OG_TITLE"] = "og:title";
    MetaTag["OG_TYPE"] = "og:type";
    MetaTag["OG_DESCRIPTION"] = "og:description";
    MetaTag["FB_APP_ID"] = "fb:app_id";
    MetaTag["FB_PAGE_ID"] = "fb:page_id";
    MetaTag["DESCRIPTION"] = "description";
    MetaTag["KEYWORDS"] = "keywords";
    MetaTag["ROBOTS"] = "robots";
    MetaTag["PRERENDER_STATUS_CODE"] = "prerender-status-code";
})(MetaTag || (MetaTag = {}));
/**
 * The meta service assists in setting different
 * types of page meta tags.
 */
var MetaService = /** @class */ (function () {
    function MetaService() {
        this.metas = new Map();
    }
    /**
     * Sets default meta information to fall back to
     * @param meta
     */
    MetaService.prototype.setDefaultTagInformation = function (meta) {
        this.metas.set(meta.name, meta.content);
        this.setMetaTag(meta);
    };
    /**
     * Sets a meta tag with the values provided
     * @param meta
     */
    MetaService.prototype.setMetaTag = function (meta) {
        var content = meta.content || this.metas.get(meta.name);
        if (!content) {
            this.removeTag(meta.name);
            return;
        }
        var tag = this.findOrCreateTag(meta.name);
        tag.setAttribute('content', content);
    };
    /**
     * Sets the page title
     * @param title
     */
    MetaService.prototype.setTitle = function (title) {
        if (!title) {
            return;
        }
        var titleTag = document.querySelector('title');
        titleTag.innerText = title;
    };
    /**
     * Gets the current meta tag or creates one
     * @param name
     */
    MetaService.prototype.findOrCreateTag = function (name) {
        var tag = this.getTag(name);
        if (tag) {
            return tag;
        }
        // Create new tag as none exists
        var createdTag = document.createElement('meta');
        if (this.isProperty(name)) {
            createdTag.setAttribute('property', name);
        }
        else {
            createdTag.setAttribute('name', name);
        }
        document.head.appendChild(createdTag);
        return createdTag;
    };
    /**
     * Removes an existing tag from the document.
     * @param name
     */
    MetaService.prototype.removeTag = function (name) {
        var tag = this.getTag(name);
        if (!tag) {
            return;
        }
        tag.parentElement.removeChild(tag);
    };
    /**
     * Gets a meta tag from the document
     * @param name
     */
    MetaService.prototype.getTag = function (name) {
        if (this.isProperty(name)) {
            return document.querySelector("meta[property='" + name + "']");
        }
        return document.querySelector("meta[name='" + name + "']");
    };
    /**
     * Checks if meta tag name should use property attribute
     * or not.
     * @param name
     */
    MetaService.prototype.isProperty = function (name) {
        return name.startsWith('og:') || name.startsWith('fb:');
    };
    return MetaService;
}());
var meta = new MetaService();

export { MetaService, MetaTag, meta };
